export default __webpack_public_path__ + "static/media/2026schedule.375fc963.png";